import apiClient from "../config/apiClient";
import { API_ENDPOINTS } from "../config/endpoints";
import { handleApiError } from "../config/errorHandler";

/**
 * Fetch branch ID from delivery areas
 * @param {number} restaurantId - The restaurant ID
 * @param {string} areaName - The name of the area
 * @returns {Promise<Object>} - Response data from the API
 */
export const getBranchDetails = async (restaurantId, areaName) => {
  try {
    const response = await apiClient.get(
      `${API_ENDPOINTS.BRANCH_ID_FROM_DELIVERY_AREAS}/3`,
      {
        params: {
          restaurant_id: restaurantId,
          area_name: areaName,
        },
      }
    );
    return response.data.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};
